import React, { useState, useEffect } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { cancelMatch, sendFriendRequest, fetchInMatchAppointmentsMatch, getCurrentUserIdFromToken, sendMatchResult } from "../Api";
import { Toast, ToastContainer } from "react-bootstrap";


import ChatModal from "./messages/GroupMessageModal";
import ReportUsersModal from "./ReportUsersModal"
import ReportModal from "./ReportMatchModal";
import RatePlayerModal from "./RatePlayerModal";

function ActiveMatches({ onClose, in_match_id, matchData }) {

    const [selectedTeamSize, setSelectedTeamSize] = useState("1v1");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedMatch, setSelectedMatch] = useState(null);
    const [chatModalOpen, setChatModalOpen] = useState(false);
    const [chatInfo, setChatInfo] = useState({ chatName: "", chatId: null });
    const [currentUserId, setCurrentUserId] = useState(null);

    const [reportModalOpen, setReportModalOpen] = useState(false);

    const [toast, setToast] = useState({ show: false, message: "", variant: "success" });
    const showToast = (message, variant = "success") => {
        setToast({ show: true, message, variant });
        setTimeout(() => setToast({ show: false, message: "", variant }), 3000); // auto-hide after 3s
    };
    const [reportUserModalOpen, setReportUserModalOpen] = useState(false);
    const [reportUserInfo, setReportUserInfo] = useState({
        match_id: null,
        user_id: null,
        profile_image: null,
        full_name: null,
    });

    const [ratePlayerModalOpen, setRatePlayerModalOpen] = useState(false);
    const [ratePlayerInfo, setRatePlayerInfo] = useState({
        match_id: null,
        user_id: null,
        profile_image: null,
        full_name: null,
    });
    const handleOpenRatePlayerModal = (player, match_id) => {
        setRatePlayerInfo({
            user_id: player.id,
            profile_image: player.avatar,
            match_id,
            full_name: player.full_name || player.name,
        });
        setRatePlayerModalOpen(true);
    };

    const handleOpenReportUserModal = (player, match_id) => {
        setReportUserInfo({
            user_id: player.id,
            profile_image: player.avatar,
            match_id,
            full_name: player.full_name || player.name, // fallback if full_name missing
        });
        setReportUserModalOpen(true);
    };
    // Add isCurrentUserLeader here:
    const isCurrentUserLeader = (match) => {

        const leaderFound = match.members.some((m) => {
            const isLeader = m.user_id === currentUserId && m.is_leader === true;
            return isLeader;
        });

        return leaderFound;
    };

    const loadMatches = () => {
        setLoading(true);
        setError(null);
        setSelectedMatch(matchData);


        setLoading(false);
    };

    useEffect(() => {
        loadMatches();
    }, [matchData]);


    useEffect(() => {
        const fetchUserId = async () => {
            const id = await getCurrentUserIdFromToken(); // 👈 wait for it
            setCurrentUserId(id);
        };
        fetchUserId();
    }, []);



    const handleBack = () => setSelectedMatch(null);

    const handleGroupChat = () => {
        if (!selectedMatch) return;
        setChatInfo({
            chatName: selectedMatch.in_match_chat_name || "unknown",
            chatId: selectedMatch.in_match_chat_group_id,  // <-- changed here
        });
        setChatModalOpen(true);
    };

    const getPlayers = (match) => {

        const team1 = match.members
            .filter((m) => m.team === 1)
            .map((m) => ({
                id: m.user_id,
                name: m.user_id === currentUserId ? "You" : m.full_name,
                avatar: m.profile_image ? `${m.profile_image}` : null,
                is_leader: m.is_leader,

            }));



        const team2 = match.members
            .filter((m) => m.team === 2)
            .map((m) => ({
                id: m.user_id,
                name: m.user_id === currentUserId ? "You" : m.full_name,
                avatar: m.profile_image ? `${m.profile_image}` : null,
                is_leader: m.is_leader,


            }));

        return { team1, team2 };
    };


    const handleSendFriendRequest = async (userId) => {
        try {
            await sendFriendRequest(userId); // call API
            alert("Friend request sent!");
        } catch (err) {
            console.error(err);
            alert("Failed to send friend request");
        }
    };



    const handleSendMatchResult = async (result) => {
        if (!selectedMatch) return;

        try {
            await sendMatchResult(selectedMatch.match_id, result);
            setSelectedMatch(null);
            await loadMatches();  // <-- refetch updated matches here
        } catch (err) {
            console.error(err);
            alert("Failed to send match result");
        }
    };




    const canShowResultButtons = (match) => {
        if (!currentUserId) {
            return false;
        }

        const currentUserMember = match.members.find(
            (m) => m.user_id === currentUserId && m.is_leader === true
        );


        const canShow = currentUserMember && currentUserMember.score === null;
        console.log(`Can show buttons? ${canShow}`);

        return canShow;
    };




    const handleReportSubmit = () => {

        setReportModalOpen(false);
    };


    return (
        <div>



            {selectedMatch && (

                <div
                    className="border rounded p-3"
                    style={{
                        boxShadow: `
      inset 0 2px 6px rgba(255, 255, 255, 0.1),   /* subtle inner highlight */
      0 6px 12px rgba(0, 0, 0, 0.5)               /* outer depth shadow */
    `,
                        borderRadius: "16px",
                        transition: "all 0.2s ease-in-out",
                        transform: "translateZ(0)",
                    }}
                >

                    <div className="d-flex justify-content-between gap-2 mt-3">
                        <button
                            className="btn btn-outline-danger px-4"
                            onClick={() => setReportModalOpen(true)}
                            type="button"
                            style={{ minWidth: "100px" }}
                        >
                            Report
                        </button>

                        {/* Insert ReportModal here */}
                        {reportModalOpen && (
                            <ReportModal
                                match_id={selectedMatch.match_id}
                                onClose={() => setReportModalOpen(false)}
                                onSubmit={handleReportSubmit}
                            />
                        )}

                        <div className="d-flex gap-2">
                            <Button
                                variant="primary"
                                onClick={handleGroupChat}
                                className="px-4"
                                style={{ minWidth: "110px" }}
                            >
                                Open Chat
                            </Button>

                            {chatModalOpen && (
                                <ChatModal
                                    chatName={chatInfo.chatName}
                                    chatId={chatInfo.chatId}
                                    onClose={() => setChatModalOpen(false)}
                                />
                            )}
                        </div>
                    </div>


                    <div className="row mb-3">
                        <div className="col-md-6">
                            <p>
                                <strong>Date:</strong>{" "}
                                <span className="badge bg-light text-dark">
                                    {new Date(selectedMatch.date).toLocaleDateString()}
                                </span>
                            </p>
                        </div>
                        <div className="col-md-6">
                            <p>
                                <strong>Match Type:</strong>{" "}
                                <span className="badge bg-light text-dark">
                                    {selectedMatch.player} | {selectedMatch.match_type}
                                </span>
                            </p>
                        </div>
                    </div>

                    <div className="mb-3">
                        <p>
                            <strong>Sport:</strong>{" "}
                            <span className="badge bg-light text-dark">
                                {selectedMatch.sport_name}
                            </span>
                        </p>
                    </div>
                    <p className="fw-bold mb-3">Players</p>


                    <div
                        className="d-flex justify-content-center gap-4 flex-wrap"
                        style={{ maxWidth: "900px", margin: "0 auto" }}
                    >

                        {/* Team 1 */}
                        <div
                            className="border rounded shadow-sm p-3 bg-white"
                            style={{ flex: "1 1 300px", minWidth: "280px" }}
                        >
                            <h6 className="text-primary mb-3">Team 1</h6>

                            <ul className="list-unstyled mb-0">
                                {getPlayers(selectedMatch).team1.map((player, idx) => (
                                    <li
                                        key={idx}
                                        className="d-flex align-items-center justify-content-between mb-2 p-2 rounded"
                                        style={{ backgroundColor: "#ca4c12ff" }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={player.avatar || "/default-avatar.png"}
                                                alt={player.name}
                                                className="rounded-circle me-3"
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    objectFit: "cover",
                                                    border: "2px solid #dee2e6",
                                                }}
                                            />
                                            <span className="fw-medium d-flex align-items-center gap-1">
                                                {player.name}
                                                {player.is_leader && (
                                                    <span
                                                        style={{
                                                            backgroundColor: "gold",
                                                            color: "#333",
                                                            borderRadius: "12px",
                                                            padding: "2px 6px",
                                                            fontSize: "0.75rem",
                                                            fontWeight: "600",
                                                            marginLeft: 6,
                                                            userSelect: "none",
                                                        }}
                                                        title="Team Leader"
                                                    >
                                                        Leader
                                                    </span>
                                                )}
                                            </span>
                                        </div>

                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ gap: 8 }}
                                        >
                                            {player.id !== currentUserId && (
                                                <>
                                                    {/* Friend */}
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #ccc",
                                                            fontWeight: "bold",
                                                            fontSize: "16px",
                                                            color: "#555",
                                                            cursor: "pointer",
                                                            userSelect: "none",
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleSendFriendRequest(player.id);
                                                        }}
                                                    >
                                                        +
                                                    </div>

                                                    {/* Rate Player */}
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #ccc",
                                                            fontSize: "16px",
                                                            color: "#f0ad4e",
                                                            cursor: "pointer",
                                                            userSelect: "none",
                                                        }}
                                                        title="Rate Player"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenRatePlayerModal(player, selectedMatch.match_id);
                                                        }}
                                                    >
                                                        ⭐
                                                    </div>

                                                    {/* Report */}
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #ccc",
                                                            fontSize: "16px",
                                                            color: "#d9534f",
                                                            userSelect: "none",
                                                            cursor: "pointer",
                                                        }}
                                                        title="Report User"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenReportUserModal(player, selectedMatch.match_id);
                                                        }}
                                                    >
                                                        🚩
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Team 2 */}
                        <div
                            className="border rounded shadow-sm p-3 bg-white"
                            style={{ flex: "1 1 300px", minWidth: "280px" }}
                        >
                            <h6 className="text-danger mb-3">Team 2</h6>
                            <ul className="list-unstyled mb-0">
                                {getPlayers(selectedMatch).team2.map((player, idx) => (
                                    <li
                                        key={idx}
                                        className="d-flex align-items-center justify-content-between mb-2 p-2 rounded"
                                        style={{ backgroundColor: "#f8f9fa" }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={player.avatar || "/default-avatar.png"}
                                                alt={player.name}
                                                className="rounded-circle me-3"
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    objectFit: "cover",
                                                    border: "2px solid #dee2e6",
                                                }}
                                            />
                                            <span className="fw-medium d-flex align-items-center gap-1">
                                                {player.name}
                                                {player.is_leader && (
                                                    <span
                                                        style={{
                                                            backgroundColor: "gold",
                                                            color: "#333",
                                                            borderRadius: "12px",
                                                            padding: "2px 6px",
                                                            fontSize: "0.75rem",
                                                            fontWeight: "600",
                                                            marginLeft: 6,
                                                            userSelect: "none",
                                                        }}
                                                        title="Team Leader"
                                                    >
                                                        Leader
                                                    </span>
                                                )}
                                            </span>
                                        </div>

                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ gap: 8 }}
                                        >
                                            {player.id !== currentUserId && (
                                                <>
                                                    {/* Friend */}
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #ccc",
                                                            fontWeight: "bold",
                                                            fontSize: "16px",
                                                            color: "#555",
                                                            cursor: "pointer",
                                                            userSelect: "none",
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleSendFriendRequest(player.id);
                                                        }}
                                                    >
                                                        +
                                                    </div>

                                                    {/* Rate Player */}
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #ccc",
                                                            fontSize: "16px",
                                                            color: "#f0ad4e",
                                                            cursor: "pointer",
                                                            userSelect: "none",
                                                        }}
                                                        title="Rate Player"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenRatePlayerModal(player, selectedMatch.match_id);
                                                        }}
                                                    >
                                                        ⭐
                                                    </div>

                                                    {/* Report */}
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            backgroundColor: "#fff",
                                                            border: "1px solid #ccc",
                                                            fontSize: "16px",
                                                            color: "#d9534f",
                                                            userSelect: "none",
                                                            cursor: "pointer",
                                                        }}
                                                        title="Report User"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenReportUserModal(player, selectedMatch.match_id);
                                                        }}
                                                    >
                                                        🚩
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>


                        {/* Modals */}
                        {reportUserModalOpen && (
                            <ReportUsersModal
                                match_id={reportUserInfo.match_id}
                                user_id={reportUserInfo.user_id}
                                profile_image={reportUserInfo.profile_image}
                                full_name={reportUserInfo.full_name}
                                onClose={() => setReportUserModalOpen(false)}
                                onSubmit={(data) => {
                                    setReportUserModalOpen(false);
                                    // handle report submission
                                }}
                            />
                        )}

                        {ratePlayerModalOpen && (
                            <RatePlayerModal
                                match_id={ratePlayerInfo.match_id}
                                user_id={ratePlayerInfo.user_id}
                                profile_image={ratePlayerInfo.profile_image}
                                full_name={ratePlayerInfo.full_name}
                                onClose={() => setRatePlayerModalOpen(false)}
                                onSubmit={(data) => {
                                    setRatePlayerModalOpen(false);
                                    // handle rating submission (API call here)
                                }}
                            />
                        )}
                    </div>

                    {/* Buttons below */}
                    {canShowResultButtons(selectedMatch) && (
                        <div
                            className="d-flex flex-column align-items-center mt-3"
                            style={{ maxWidth: "900px", margin: "0 auto" }}
                        >
                            <div className="d-flex gap-3">
                                <button
                                    className="btn btn-success"
                                    onClick={async () => {
                                        await handleSendMatchResult(true);
                                        if (onClose) onClose(); // ✅ close modal
                                    }}
                                >
                                    Win
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={async () => {
                                        await handleSendMatchResult(false);
                                        if (onClose) onClose(); // ✅ close modal
                                    }}
                                >
                                    Lose
                                </button>
                            </div>
                            <button
                                className="btn btn-link mt-2 p-0 text-decoration-none"
                                style={{ color: "#6c757d" }}
                                onClick={async () => {
                                    if (!selectedMatch) return;

                                    try {

                                        console.log(selectedMatch.match_id);
                                        await cancelMatch(selectedMatch.match_id);
                                        showToast("Match cancelled successfully!", "success");
                                        setSelectedMatch(null);
                                        // await loadMatches();
                                        //  if (onClose) onClose(); // ✅ close modal

                                    } catch (err) {

                                        console.error(err);
                                        const msg = err.response?.data?.detail;
                                        showToast(typeof msg === 'string' ? msg : JSON.stringify(msg), "danger");
                                        //   onClose();
                                    }
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    )}



                    <ToastContainer position="top-end" className="p-3">
                        <Toast bg={toast.variant} onClose={() => setToast({ ...toast, show: false })} show={toast.show} delay={3000} autohide>
                            <Toast.Body className={toast.variant === "danger" ? "text-white" : ""}>
                                {toast.message}
                            </Toast.Body>
                        </Toast>
                    </ToastContainer>


                </div>

            )}



        </div>
    );

}

export default ActiveMatches;
